import axios from "axios";
import authHeader from "./jwt-token-access/auth-token-header";

const BASE_API_URL = process.env.REACT_APP_API_URL;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: BASE_API_URL,
  timeout: 10000,
});

// Request interceptor to add auth header
apiClient.interceptors.request.use(
  (config) => {
    const authHeaders = authHeader();
    if (authHeaders.Authorization) {
      config.headers.Authorization = authHeaders.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear session and redirect to login
      sessionStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Named exports for backward compatibility
export async function get(url, config = {}) {
  return await apiClient
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return apiClient
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return apiClient
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await apiClient
    .delete(url, { ...config })
    .then((response) => response.data);
}

export default apiClient;
